export function downloadBlobAsFile(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob instanceof Blob ? blob : new Blob([blob]))
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)

    try {
        link.click()
    } finally {
        link.parentNode?.removeChild(link)
        window.URL.revokeObjectURL(url)
    }
}

export default downloadBlobAsFile
